<script>
import Service from '../../services/vessel-protocol';
import config from '../../common/genericPanelConf';

import CommonConstants from '../../common/Constants';
import Utils from '../../common/Utils';

import Button from 'primevue/button';

import { required, maxLength, minValue  } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default{
  setup: () => ({ v$: useVuelidate() }),
  props: ['vesselProtocolId', 'isDisabled'],
  emits: ['updateAccertedQuantity', 'updatePayments'],

  components: {
    Button,
},
  data(){
    return {
      data: {},
    }
  },
  validations(){
    return {
    }
  },
  computed: {
    constants(){
        return CommonConstants;
    },
    utils(){
      return Utils;
    },
    uiPermissions(){
      return this.$store.getters['security/uiPermissions'];
    }
  },
  created(){
    this.config = config.getConfiguration('VesselProtocol').loading;
  },
  mounted(){
    this.loadData();
  },
  watch: {
    
  },
  methods: {
    loadData(){
      Service.getVesselProtocolLoading(this.vesselProtocolId, ({success, data, notFound, message}) => {
        if(success){
          this.data = data;
          if(this.data.shoreWeightBoL){
            this.$emit('updateAccertedQuantity', this.data.shoreWeightBoL, null);
          }
        } else if(!notFound){
          this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
        }
      })
    },
    updateData(){
      if(this.data.id){
        Service.updateVesselProtocolLoading(this.data, ({success, message}) => {
          if(success){
            this.$emit('updatePayments');
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          } else {
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      } else {
        Service.addVesselProtocolLoading(this.data, ({success, message}) => {
          if(success){
            this.$emit('updatePayments');
            this.loadData();
            this.$toast.add({severity:'success', summary: 'Success Message', detail: this.$t('messages.update_message_success'), life: 3000});
          } else {
            this.$toast.add({detail: message && message != '' ? message :  this.$t('messages.generic_error_message'), life:3000, severity:'error'});
          }
        })
      }
    }
  },
}

</script>

<template>
  <main>
    <div class="grid">
      <div class="col-12">
        <Toolbar>
          <template #start>
            <Button :label="$t('btn.save')" icon="pi pi-save" @click="updateData" :disabled="!uiPermissions('vesselProtocolLoadingSaveButton').isEnabled || isDisabled" v-if="!uiPermissions('vesselProtocolLoadingSaveButton').isHidden" />
          </template>
        </Toolbar>
      </div>
      <div v-for="fieldset in config.fieldsets" class="col-12 lg:col-6" :key="fieldset">
        <Fieldset :legend="$t(fieldset.label)" class="h-100">
            <div class="grid">
              <template v-for="field in fieldset.fields" :key="field">
                <div class="col-12" :class="field.name != 'notes' ? 'lg:col-6' : ''">
                  <label v-tooltip="$t('vesselProtocol.' + field.label)" class="short-label">
                    {{ $t('vesselProtocol.' + field.label) }}
                  </label>
                  <label><b>{{ '[' + (field.uom ?? ' - ') + ']'}}</b></label>
                  <label class="d-block" v-if="field.readOnly">
                    {{ (data[field.name] ?? '-') }}
                  </label>
                  <template v-else>
                    <InputText 
                      v-if="field.type == 'text'"
                      v-model="data[field.name]"
                      type="text"
                      :readonly="field.readOnly"
                      class="w-full p-inputtext-sm m-1" />
                    <InputNumber
                      v-if="field.type == 'number'"
                      v-model="data[field.name]"
                      :readonly="field.readOnly"
                      class="w-full p-inputtext-sm m-1" />
                    <InputNumber
                      v-if="field.type == 'decimal'"
                      mode="decimal" :maxFractionDigits="field.digits"
                      v-model="data[field.name]"
                      :readonly="field.readOnly"
                      class="w-full p-inputtext-sm m-1" />
                    <Textarea
                      v-if="field.type == 'textarea'"
                      v-model="data[field.name]"
                      :readonly="field.readOnly"
                      class="w-full m-1 h-10rem" />
                  </template>
                  <p v-if="field.percentageField"><b>{{ '[%]: ' + (data[field.percentageField] ?? '-') }}</b></p>
                </div>
              </template>
            </div>
        </Fieldset>
      </div>
    </div>
  </main>
</template>

<style scoped>

.short-label {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.d-block {
  display: block;
}

.h-100 {
  height: 100%;
}

</style>